/**
 * Acquisition source capture.
 *
 * Reads UTM params + referrer at first page load and pins them to
 * sessionStorage. Register endpoint reads `getAcquisition()` at submit time so
 * the signup carries the source that got them here — even if they clicked
 * around before creating an account.
 */

const STORAGE_KEY = 'copr:acquisition'

function _readFromUrl() {
  try {
    const u = new URL(window.location.href)
    const p = u.searchParams
    const source = p.get('utm_source') || p.get('ref') || ''
    const medium = p.get('utm_medium') || ''
    const campaign = p.get('utm_campaign') || ''
    let referrerHost = ''
    try {
      if (document.referrer) referrerHost = new URL(document.referrer).host
    } catch { /* opaque referrer */ }
    return {
      source: (source || referrerHost || 'direct').slice(0, 60),
      medium: medium.slice(0, 60),
      campaign: campaign.slice(0, 100),
    }
  } catch {
    return { source: 'direct', medium: '', campaign: '' }
  }
}

/** Capture acquisition on first load if not already captured. */
export function captureAcquisition() {
  if (typeof window === 'undefined') return
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(_readFromUrl()))
  } catch { /* private mode */ }
}

/** Read captured acquisition (returns nulls if none). */
export function getAcquisition() {
  if (typeof window === 'undefined') return { source: null, medium: null, campaign: null }
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (raw) return JSON.parse(raw)
  } catch { /* corrupted */ }
  return { source: null, medium: null, campaign: null }
}
